import * as types from "./types";

/**
 * Reducer du domaine Invoice + FinancialTransaction.
 *
 * <p>{@code GET /invoice/by-patient/{id}} renvoie un tableau plat ;
 * on le stocke directement dans {@code invoices}.
 */

const INITIAL_STATE = {
  // listing
  getting_invoices: false,
  invoices: [],

  // détail
  getting_invoice: false,
  current_invoice: null,

  // mutations
  creating_invoice: false,
  deleting_invoice: false,
  marking_paid_cash: false,
  initiating_payment: false,
  paymentPayload: null,

  // financial transactions
  getting_financial_transactions: false,
  financial_transactions: [],
  assigning_transaction: false,

  errors: []
};

function InvoicesReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    /* ----------------------- create ----------------------- */
    case types.CREATE_INVOICE_REQUEST:
      return { ...state, creating_invoice: true, errors: [] };
    case types.CREATE_INVOICE_SUCCESS:
      return {
        ...state,
        creating_invoice: false,
        current_invoice: action.payload || state.current_invoice
      };
    case types.CREATE_INVOICE_FAILURE:
      return {
        ...state,
        creating_invoice: false,
        errors: action.payload || []
      };

    /* ----------------------- delete ----------------------- */
    case types.DELETE_INVOICE_REQUEST:
      return { ...state, deleting_invoice: true, errors: [] };
    case types.DELETE_INVOICE_SUCCESS: {
      const deletedId = action.payload?.id;
      return {
        ...state,
        deleting_invoice: false,
        invoices: deletedId != null
          ? state.invoices.filter((inv) => inv?.id !== deletedId)
          : state.invoices,
        current_invoice:
          state.current_invoice?.id === deletedId ? null : state.current_invoice
      };
    }
    case types.DELETE_INVOICE_FAILURE:
      return {
        ...state,
        deleting_invoice: false,
        errors: action.payload || []
      };

    /* --------------------- get by id ---------------------- */
    case types.GET_INVOICE_BY_ID_REQUEST:
      return { ...state, getting_invoice: true, errors: [] };
    case types.GET_INVOICE_BY_ID_SUCCESS:
      return {
        ...state,
        getting_invoice: false,
        current_invoice: action.payload
      };
    case types.GET_INVOICE_BY_ID_FAILURE:
      return {
        ...state,
        getting_invoice: false,
        errors: action.payload || []
      };

    /* ----------------- get by patient (liste plate) ----------------- */
    case types.GET_INVOICES_BY_PATIENT_REQUEST:
      return { ...state, getting_invoices: true, errors: [] };
    case types.GET_INVOICES_BY_PATIENT_SUCCESS:
      return {
        ...state,
        getting_invoices: false,
        invoices: Array.isArray(action.payload) ? action.payload : []
      };
    case types.GET_INVOICES_BY_PATIENT_FAILURE:
      return {
        ...state,
        getting_invoices: false,
        errors: action.payload || []
      };

    /* -------------------- initiate payment -------------------- */
    case types.INITIATE_PAYMENT_REQUEST:
      return { ...state, initiating_payment: true, paymentPayload: null, errors: [] };
    case types.INITIATE_PAYMENT_SUCCESS:
      return {
        ...state,
        initiating_payment: false,
        paymentPayload: action.payload || null
      };
    case types.INITIATE_PAYMENT_FAILURE:
      return {
        ...state,
        initiating_payment: false,
        errors: action.payload || []
      };

    /* -------------------- mark paid cash -------------------- */
    case types.MARK_INVOICE_AS_PAID_CASH_REQUEST:
      return { ...state, marking_paid_cash: true, errors: [] };
    case types.MARK_INVOICE_AS_PAID_CASH_SUCCESS:
      return { ...state, marking_paid_cash: false };
    case types.MARK_INVOICE_AS_PAID_CASH_FAILURE:
      return {
        ...state,
        marking_paid_cash: false,
        errors: action.payload || []
      };

    /* -------------------- financial transactions -------------------- */
    case types.GET_FINANCIAL_TRANSACTIONS_REQUEST:
      return { ...state, getting_financial_transactions: true, errors: [] };
    case types.GET_FINANCIAL_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        getting_financial_transactions: false,
        financial_transactions: Array.isArray(action.payload)
          ? action.payload
          : []
      };
    case types.GET_FINANCIAL_TRANSACTIONS_FAILURE:
      return {
        ...state,
        getting_financial_transactions: false,
        errors: action.payload || []
      };

    case types.ASSIGN_TRANSACTION_TO_INVOICE_REQUEST:
      return { ...state, assigning_transaction: true, errors: [] };
    case types.ASSIGN_TRANSACTION_TO_INVOICE_SUCCESS:
      return { ...state, assigning_transaction: false };
    case types.ASSIGN_TRANSACTION_TO_INVOICE_FAILURE:
      return {
        ...state,
        assigning_transaction: false,
        errors: action.payload || []
      };

    default:
      return state;
  }
}

export default InvoicesReducer;
